export default __webpack_public_path__ + "static/media/logo.40877a05.png";